module.exports = __webpack_public_path__ + "res/materialdesignicons-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/lumx/fonts/materialdesignicons-webfont.eot
// module id = 109
// module chunks = 1